import { api } from 'webReservations/api';
import type {
  AvailabilityImpressionSnapshot,
  GuestPricingImpressionActionType,
} from './guestPricingTypes';

export interface GuestPricingImpressionEventPayload {
  actionType: GuestPricingImpressionActionType;
  clientTimestamp: string;
  availabilities: AvailabilityImpressionSnapshot[];
}

export const postGuestPricingImpressionsBatch = async ({
  restaurantId,
  sessionId,
  events,
}: {
  restaurantId: string;
  sessionId: string;
  events: GuestPricingImpressionEventPayload[];
}): Promise<void> => {
  await api.post(`/restaurants/${restaurantId}/guest-pricing-impressions`, {
    sessionId,
    events,
  });
};

export const postGuestPricingConversion = async ({
  restaurantId,
  sessionId,
  clientTimestamp,
  reservationId,
  offerId,
}: {
  restaurantId: string;
  sessionId: string;
  clientTimestamp: string;
  reservationId?: string;
  offerId?: string;
}): Promise<void> => {
  await api.post(`/restaurants/${restaurantId}/guest-pricing-conversions`, {
    sessionId,
    clientTimestamp,
    reservationId,
    offerId,
  });
};
